module.exports = __webpack_public_path__ + "static/media/adesh.3bddfd98.png";